<template>
  <template-card
    :name="name"
    preview-width="150px"
    preview-height="2px"
    icon="$paper_line"
    @dragend:item="addItemDrop()"
    @click:item="addItem()" />
</template>
<script>
import paperBuilderToolMixin from '@/mixins/paperBuilderToolMixin'
import { v4 as uuid } from 'uuid'
import TemplateCard from './TemplateCard.vue'

export default {
  components: { TemplateCard },
  mixins: [
    paperBuilderToolMixin
  ],
  methods: {
    addItem () {
      const { left, top } = this.paperBuilderDrop || { left: '20px', top: '20px' }
      this.addPaperBuilderCanvas({
        id: this.paperBuilderId,
        data: {
          id: uuid(),
          type: 'line',
          tag: 'div',
          properties: {
            style: {
              position: 'absolute',
              left,
              top,
              width: '150px',
              height: '2px',
              borderColor: '#EF2F2FFF',
              borderTopWidth: '2px',
              borderRightWidth: '0px',
              borderLeftWidth: '0px',
              borderBottomWidth: '0px',
              borderStyle: 'solid'
            }
          },
          children: []
        }
      })
    }
  }
}
</script>
<style scoped>

</style>
